var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"color":"primary"},on:{"click":_vm.signIn}},'v-btn',_vm.$attrs,false),[_vm._v("Login")])}
var staticRenderFns = []

export { render, staticRenderFns }